import { Component } from 'react';
import { CvvEventHandler, CvvEventHandlerRegistrar } from '../createPciProxyService';

export interface PciProxyCVVProps {
    className?: string;
    id: string;
    onMetadataChange?: CvvEventHandler;
    onFocus?: CvvEventHandler;
    onBlur?: CvvEventHandler;
    registerChange: CvvEventHandlerRegistrar;
    registerFocus: CvvEventHandlerRegistrar;
    registerBlur: CvvEventHandlerRegistrar;
}

export default class PciProxyCvv extends Component<PciProxyCVVProps> {
    componentDidMount() {
        const { onMetadataChange, onBlur, onFocus } = this.props;

        if (onMetadataChange) {
            this.props.registerChange(onMetadataChange);
        }

        if (onFocus) {
            this.props.registerFocus(onFocus);
        }

        if (onBlur) {
            this.props.registerBlur(onBlur);
        }
    }

    render() {
        const { id, className } = this.props;
        const props = { id, className };

        return <div data-test-id="field-pci-proxy-cvv" {...props} />;
    }
}
